import { render, staticRenderFns } from "./PlaceMenu.vue?vue&type=template&id=038e43c2&scoped=true&"
import script from "./PlaceMenu.vue?vue&type=script&lang=js&"
export * from "./PlaceMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlaceMenu.vue?vue&type=style&index=0&id=038e43c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e43c2",
  null
  
)

export default component.exports